import { render, staticRenderFns } from "./CommonButton.vue?vue&type=template&id=09ef20ac&scoped=true&"
import script from "./CommonButton.vue?vue&type=script&lang=js&"
export * from "./CommonButton.vue?vue&type=script&lang=js&"
import style0 from "./CommonButton.vue?vue&type=style&index=0&id=09ef20ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ef20ac",
  null
  
)

export default component.exports